import { Flex, Text, Textarea } from "@chakra-ui/react";

export const ObservacoesFornecedor = ({ register, errors, dadosObservacoes }) => {
  return (
    dadosObservacoes ? (
      <Flex flexDir="column">
        <Flex flexDir="column" mt="1rem" py="1rem" bg="#378BBF" color="white">
          <Text textAlign="center">OBSERVAÇÕES PARA O FORNECEDOR</Text>
        </Flex>
        <Textarea
          placeholder="Digite aqui as observações para o fornecedor"
          mt="1rem"
          defaultValue={dadosObservacoes}
          {...register("observacaoFornecedor")}
        />
        {errors && (
          <Text color="red.500">{errors.observacaoFornecedor?.message}</Text>
        )}
      </Flex>
    ) : (<Text>Loading...</Text>)
  );
};
